import { getAxiosConfig } from "@/services/axiosConfig";
import { IBrands, IBrandsGeneric } from "global-types/global.types";
import { useQuery } from "react-query";

export default function useBrandsFilter(slug: string) {
  const { data: brandsFilter, isLoading: isLoadingBrandsFilter } = useQuery(
    ["BRANDS_FILTER", slug],
    async () => {
      const res = await getAxiosConfig().get<IBrands<IBrandsGeneric[]>>(
        `/brand/withcategory?category=${slug}`
      );

      return res.data;
    }
  );

  return { brandsFilter, isLoadingBrandsFilter };
}
